import * as ng from 'angular';

ng.module('e360')
   .filter('capitalize', () => capitalizeFilter);

export function capitalizeFilter(val:string) {
   return val.charAt(0).toUpperCase() + val.substring(1).toLowerCase();
}
